document.addEventListener("DOMContentLoaded", function () {
  const sliderElement = document.querySelector(".split-hero-slider");

  if (!sliderElement) return;

  const getAutoplaySettings = () => {
    if (sliderElement.dataset.autoplay !== "true") return false;

    try {
      return { delay: parseInt(sliderElement.dataset.autoplaySpeed) * 1000 };
    } catch (e) {
      return { delay: 4000 };
    }
  };

  const slideChange = ({ realIndex }) => {
    const currentIndex = String(realIndex + 1).padStart(2, 0);
    const paginationElement = document.querySelector(
      ".split-hero-navigation__current-page"
    );

    if (!paginationElement) return;
    else paginationElement.innerHTML = currentIndex;
  };

  const slider = new Swiper(".split-hero-slider", {
    autoplay: getAutoplaySettings(),
    effect: "fade",
    loop: true,
    allowTouchMove: false,
    fadeEffect: { crossFade: true },
    navigation: {
      prevEl: ".split-hero-navigation__button--prev",
      nextEl: ".split-hero-navigation__button--next",
    },
    on: { slideChange },
  });
});
